// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-view {
  position: fixed;
  top: 46px;
  left: 50px;
  bottom: 0;
  overflow: auto;
  right: 0;
  transition: 0.3s ease;
}
.main-view img {
  max-width: 100%;
  height: auto;
}
.main-view.side-menu-open {
  left: 195px;
}

.main-view-1 {
  position: fixed;
  top: 46px;
  left: 0px;
  bottom: 0;
  overflow: auto;
  right: 0;
  transition: 0.3s ease;
}
.main-view-1 img {
  max-width: 100%;
  height: auto;
}
.main-view-1.side-menu-open {
  left: 195px;
}

.main-view-side {
  position: fixed;
  top: 46px;
  left: 355px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side img {
  max-width: 100%;
  height: auto;
}

.main-view-side2 {
  position: fixed;
  top: 46px;
  left: 195px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side2 img {
  max-width: 100%;
  height: auto;
}

.main-view-side3 {
  position: fixed;
  top: 46px;
  left: 55px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side3 img {
  max-width: 100%;
  height: auto;
}

.main-view-side4 {
  position: fixed;
  top: 42px;
  left: 355px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side4 img {
  max-width: 100%;
  height: auto;
}

.main-view-side5 {
  position: fixed;
  top: 43px;
  left: 510px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side5 img {
  max-width: 100%;
  height: auto;
}

.main-view-side6 {
  position: fixed;
  top: 42px;
  left: 190px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side6 img {
  max-width: 100%;
  height: auto;
}

.main-view-side7 {
  position: fixed;
  top: 43px;
  left: 34px;
  bottom: 0;
  overflow: auto;
  right: 0;
  padding: 20px;
}
.main-view-side7 img {
  max-width: 100%;
  height: auto;
}

.notification-info ~ .no-sidebar {
  top: 77px;
}

.no-sidebar {
  left: 50px;
  top: 46px;
  bottom: 27px;
}
.no-sidebar .main-view-side {
  position: fixed;
  top: 46px;
  left: 355px;
  bottom: 0;
  overflow: auto;
  right: 0;
}
.no-sidebar .main-view-side img {
  max-width: 100%;
  height: auto;
}

.has-padding {
  overflow: auto;
  padding: 20px;
  /* Nested scroll fix: only .main-view scrolls */
}
.has-padding--single-scroll {
  overflow: visible !important;
  max-height: none !important;
}

.visible-responsive {
  display: none !important;
}

.mt-0 {
  margin-top: 0 !important;
}

@media (max-width: 1100px) {
  .main-view {
    left: 50;
  }
}
@media (max-width: 959px) {
  .main-view {
    left: 50;
  }
  .sidebar-collapse .main-view {
    left: 0;
  }
  .hidden-responsive {
    display: none !important;
  }
  .visible-responsive {
    display: block !important;
  }
}
@media (max-width: 499px) {
  .main-view {
    bottom: 28px;
  }
}
.MuiTabs-scroller.MuiTabs-fixed {
  overflow: auto !important;
}

.breadcrumb-row > .MuiGrid-item {
  height: 50px;
  align-items: center;
  display: flex;
}
.breadcrumb-row > .MuiGrid-item > div {
  width: 100%;
}
.breadcrumb-row > .users-list-actions {
  flex-wrap: nowrap !important;
  overflow: hidden;
}
.breadcrumb-row > .users-list-actions > div {
  width: auto;
}
.breadcrumb-row > .users-list-actions .users-list-actions__field {
  flex: 1 1;
  min-width: 0;
  max-width: 180px;
}
.breadcrumb-row > .users-list-actions .users-list-actions__btn {
  flex: 0 0 auto;
  width: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/Layout/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,SCea;EDdb,UAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,qBAAA;AAAF;AACE;EACE,eAAA;EACA,YAAA;AACJ;AACE;EACE,WAAA;AACJ;;AAEA;EACE,eAAA;EACA,SCDa;EDEb,SAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,qBAAA;AACF;AAAE;EACE,eAAA;EACA,YAAA;AAEJ;AAAE;EACE,WAAA;AAEJ;;AACA;EACE,eAAA;EACA,SCjBa;EDkBb,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAEF;AADE;EACE,eAAA;EACA,YAAA;AAGJ;;AAAA;EACE,eAAA;EACA,SC9Ba;ED+Bb,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAGF;AAFE;EACE,eAAA;EACA,YAAA;AAIJ;;AADA;EACE,eAAA;EACA,SC3Ca;ED4Cb,UAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAIF;AAHE;EACE,eAAA;EACA,YAAA;AAKJ;;AAFA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAKF;AAJE;EACE,eAAA;EACA,YAAA;AAMJ;;AAHA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAMF;AALE;EACE,eAAA;EACA,YAAA;AAOJ;;AAJA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAOF;AANE;EACE,eAAA;EACA,YAAA;AAQJ;;AALA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAQF;AAPE;EACE,eAAA;EACA,YAAA;AASJ;;AANA;EACE,SAAA;AASF;;AAPA;EACG,UAAA;EACA,SC/GY;EDgHZ,YC/GY;ADyHf;AARE;EACE,eAAA;EACA,SCpHW;EDqHX,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;AAUJ;AATI;EACE,eAAA;EACA,YAAA;AAWN;;AANA;EACE,cAAA;EACA,aAAA;EAEA,+CAAA;AAQF;AAPE;EACE,4BAAA;EACA,2BAAA;AASJ;;AANA;EACE,wBAAA;AASF;;AALA;EACE,wBAAA;AAQF;;AALA;EACE;IACE,QAAA;EAQF;AACF;AANA;EACE;IACE,QAAA;EAQF;EAJE;IACE,OAAA;EAMJ;EAHA;IACE,wBAAA;EAKF;EAHA;IACE,yBAAA;EAKF;AACF;AAFA;EACE;IACE,YAAA;EAIF;AACF;AADA;EACE,yBAAA;AAGF;;AACE;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AAEJ;AADI;EACE,WAAA;AAGN;AAEE;EACE,4BAAA;EACA,gBAAA;AAAJ;AAEI;EACE,WAAA;AAAN;AAGI;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AADN;AAII;EACE,cAAA;EACA,sBAAA;AAFN","sourcesContent":["@import \"./../assets/variables\";\n.main-view {\n  position: fixed;\n  top: $headerHeight;\n  left: 50px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  transition: 0.3s ease;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n  &.side-menu-open {\n    left: 195px;\n  }\n}\n.main-view-1 {\n  position: fixed;\n  top: $headerHeight;\n  left: 0px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  transition: 0.3s ease;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n  &.side-menu-open {\n    left: 195px;\n  }\n}\n.main-view-side {\n  position: fixed;\n  top: $headerHeight;\n  left: 355px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.main-view-side2 {\n  position: fixed;\n  top: $headerHeight;\n  left: 195px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.main-view-side3 {\n  position: fixed;\n  top: $headerHeight;\n  left: 55px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.main-view-side4 {\n  position: fixed;\n  top: 42px;\n  left: 355px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.main-view-side5 {\n  position: fixed;\n  top:43px;\n  left: 510px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.main-view-side6 {\n  position: fixed;\n  top: 42px;\n  left: 190px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.main-view-side7 {\n  position: fixed;\n  top: 43px;\n  left: 34px;\n  bottom: 0; //$footerHeight;\n  overflow: auto;\n  right: 0;\n  padding: 20px;\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.notification-info ~ .no-sidebar {\n  top: $headerHeight + 31px;\n} \n.no-sidebar {\n   left: 50px;\n   top: $headerHeight;\n   bottom: $footerHeight;\n\n  .main-view-side {\n    position: fixed;\n    top: $headerHeight;\n    left: 355px;\n    bottom: 0; //$footerHeight;\n    overflow: auto;\n    right: 0;\n    img {\n      max-width: 100%;\n      height: auto;\n    }\n  }\n}\n\n.has-padding {\n  overflow: auto;\n  padding: 20px;\n\n  /* Nested scroll fix: only .main-view scrolls */\n  &--single-scroll {\n    overflow: visible !important;\n    max-height: none !important;\n  }\n}\n.visible-responsive {\n  display: none !important;\n}\n\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n@media (max-width: 1100px) {\n  .main-view {\n    left: 50;\n  }\n}\n@media (max-width: 959px) {\n  .main-view {\n    left: 50;\n  }\n\n  .sidebar-collapse {\n    .main-view {\n      left: 0;\n    }\n  }\n  .hidden-responsive {\n    display: none !important;\n  }\n  .visible-responsive {\n    display: block !important;\n  }\n}\n\n@media (max-width: 499px) {\n  .main-view {\n    bottom: 28px;\n  }\n}\n\n.MuiTabs-scroller.MuiTabs-fixed {\n  overflow: auto !important;\n}\n\n.breadcrumb-row {\n  > .MuiGrid-item {\n    height: 50px;\n    align-items: center;\n    display: flex;\n    > div {\n      width: 100%;\n    }\n  }\n\n  // Users list right-side actions: one row, with gap after tabs\n  > .users-list-actions {\n    flex-wrap: nowrap !important;\n    overflow: hidden;\n\n    > div {\n      width: auto;\n    }\n\n    .users-list-actions__field {\n      flex: 1 1 0;\n      min-width: 0;\n      max-width: 180px;\n    }\n\n    .users-list-actions__btn {\n      flex: 0 0 auto;\n      width: auto !important;\n    }\n  }\n}","@import 'functions';\n@import 'mixins';\n$themeColor: #1a1d4f;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
